// Helpers for building storage object keys from user-supplied values (filenames,
// ids) without letting a crafted value escape its intended prefix (CWE-35 path
// traversal). Storage keys aren't a filesystem, but sanitizing keeps keys
// predictable and satisfies static analysis.

function cleanSegment(s: string): string {
  return s
    .replace(/[^a-zA-Z0-9._-]/g, '_') // no slashes, spaces, control chars
    .replace(/\.{2,}/g, '_')          // collapse ".." so it can't traverse
    .replace(/^\.+/, '');             // no leading dots
}

// Sanitize a single path segment (slashes are removed).
export function sanitizeStorageSegment(seg: string | null | undefined, fallback = 'file'): string {
  return cleanSegment(String(seg ?? '')).slice(0, 100) || fallback;
}

// Sanitize a multi-segment storage prefix, preserving "/" between segments but
// cleaning each segment so no part can traverse.
export function sanitizeStoragePath(path: string | null | undefined, fallback = 'uploads'): string {
  const cleaned = String(path ?? '')
    .split('/')
    .map(cleanSegment)
    .filter(Boolean)
    .join('/');
  return cleaned || fallback;
}

// Sanitize a file extension derived from a filename to a short alphanumeric token.
export function sanitizeFileExt(name: string | null | undefined, fallback = 'bin'): string {
  const ext = String(name ?? '').split('.').pop() || '';
  const cleaned = ext.replace(/[^a-zA-Z0-9]/g, '').toLowerCase().slice(0, 10);
  return cleaned || fallback;
}
